import {OnboardedCountry} from '@/types/Markets'
import type {IDataTableProps} from 'pepsico-ds'
import {IntlFormatters} from 'react-intl'
import {AuditCell, CountryNameCell, MarketStatusBadge} from './CustomCells'

// column keys match the API fields so pepsico-ds can sort the rows client-side
export const getTableColumns = (
  formatMessage: IntlFormatters['formatMessage']
): IDataTableProps<OnboardedCountry>['columns'] => [
  {
    columnKey: 'name',
    header: formatMessage({id: 'MARKETS.TABLE_COUNTRY_COLUMN'}),
    enableSorting: true,
    initialSize: 250,
    cellData: ({row}) => <CountryNameCell name={row.original.name} code={row.original.code} />,
  },
  {
    columnKey: 'status',
    header: formatMessage({id: 'MARKETS.TABLE_STATUS_COLUMN'}),
    enableSorting: true,
    initialSize: 150,
    cellData: ({row}) => <MarketStatusBadge status={row.original.status} />,
  },
  {
    columnKey: 'create_date',
    header: formatMessage({id: 'MARKETS.TABLE_CREATED_COLUMN'}),
    enableSorting: true,
    initialSize: 180,
    cellData: ({row}) => <AuditCell date={row.original.create_date} user={row.original.createdBy} />,
  },
  {
    columnKey: 'update_date',
    header: formatMessage({id: 'MARKETS.TABLE_UPDATED_COLUMN'}),
    enableSorting: true,
    initialSize: 180,
    cellData: ({row}) => <AuditCell date={row.original.update_date} user={row.original.updatedBy} />,
  },
]
